module.exports = __webpack_public_path__ + "static/img/edit.9b28e5cc.svg";